import React, { Component } from 'react'
import './style.css'
import {Button} from '@material-ui/core'
import event1 from '../../assets/image/event1.jpg'

export default class grid extends Component {
    
    render() {
        let headline=[]
        let subheadline=[]
        let {jumlah}=this.props
        // console.log(jumlah,this.props.data)
        this.props.data.map((data,i)=>{
            if(i>0){
                // subheadline.push(data)
                if(jumlah!==undefined){
                    for (let index = 0; index <= jumlah;i++) {
                        // const element = array[index];
                        subheadline.push(data)
                    }
                }else{
                    subheadline.push(data)
                }
            }else{
                headline.push(data)
            }
        })
        let prev

        if(headline.length>0){
            // console.log('headline', headline)
        let a=headline[0].extract.match(/<p>(.*?)<\/p>/g); 
        if(a!==null){
            prev= a[0].replace(/<\/?[^>]+(>|$)/g, "")

        }else{
            prev=''
        }
        }
       
        return (
            <div>
                {headline.length>0&&
                <div className='grid-wrapper'>
                    <div className='headline' onClick={()=>window.location.assign(`https://content.gmlperformance.com/insight/${headline[0].slug}`)}>
                        <div className="overlay">
                                <img src={headline[0].thumbnail} alt="insight" className="img-box-big"/>
                                <div className="caption">
                                    <div style={{display:'flex',justifyContent:'space-between'}}>
                                        <h3>{headline[0].categories[0].text}</h3>
                                        {/* <h3>{headline[0].subtitle}</h3> */}
                                    </div>
                                    <br/>
                                    <h1>{headline[0].title.length>70?`${headline[0].title.substring(0,54)}...`:headline[0].title}</h1>
                                    <br/>
                                    <p>{prev}</p>
                                    <div className='grid2-footer'>
                                        <Button style={{textTransform:'none',fontWeight:'bold',padding:0}} color="primary" onClick={()=>window.location.assign(`https://content.gmlperformance.com/insight/${headline[0].slug}`)}>Read more </Button>
                                    </div>
                                    
                                </div>
                            </div>
                    </div>
                    {subheadline.map((subheadline,i)=>(
                       <div className='subheadline' key={i}  onClick={()=>window.location.assign(`https://content.gmlperformance.com/insight/${subheadline.slug}`)}>
                        <div className='overlay-small'>
                            <img src={subheadline.thumbnail} alt="event" className="img-box-small"  />
                            <div className='show-mobile type-event'>
                                <p ></p>
                            </div>
                            <div className='card'>
                                    <div style={{display:'flex',justifyContent:'space-between'}}>
                                        <h6>{subheadline.categories.length>0&&subheadline.categories[0].text}</h6>
                                        <h6 className='hidden-desktop'></h6>
                                    </div>
                                    <h3 className='title-splice'>{subheadline.title.length>66?`${subheadline.title.substring(0,65)}...`:subheadline.title}</h3>
                                    <div className='grid2-footer'>
                                        <Button style={{textTransform:'none',fontWeight:'bold',padding:0}} color="primary" onClick={()=>window.location.assign(`https://content.gmlperformance.com/insight/${subheadline.slug}`)}>Read more </Button>

                                    </div>
                            </div>
                        </div>
                    </div>
                    ))}
                    
                   
                </div>
                }
            </div>
        )
    }
}
